import axios from "axios";
import Constants from "customs/config/Constants";

const axiosAuth = axios.create({
    "baseURL": Constants.API_URL
});

export default axiosAuth;
